import { createSlice } from '@reduxjs/toolkit';
import { flow } from 'fp-ts/function';
import { get, stubTrue } from 'lodash/fp';

import { moduleId } from '../constants';

export const VOUCHER_SLICE_NAME = 'voucherVisible';

const voucherSlice = createSlice({
    name: VOUCHER_SLICE_NAME,
    initialState: false,
    reducers: {
        showVoucherCodeInput: stubTrue,
    },
});

export const { showVoucherCodeInput } = voucherSlice.actions;

const moduleSelector = get(moduleId);

export const isVoucherCodeInputVisible = flow(moduleSelector, get(VOUCHER_SLICE_NAME));

export const { reducer: voucherReducer } = voucherSlice;
